import CustomModal from "../v3components/shared/Modal/CustomModal.vue"
import { reactive, shallowRef, nextTick } from "vue"

const canRestoreFocus = (target) => {
  if (!target || typeof target.focus !== "function") return false
  if (target.isConnected === false) return false
  if ("ownerDocument" in target && target.ownerDocument) {
    return target.ownerDocument.contains(target)
  }
  return true
}

const restoreFocus = (target) => {
  if (!canRestoreFocus(target)) return
  try {
    target.focus()
  } catch {
    /* no-op: focus may fail in edge browser/DOM states */
  }
}

const modalPlugin = (app) => {
  app.component("CustomModal", CustomModal)
  const modalConfig = reactive({
    component: null,
    options: {
      visible: false,
      size: "sm",
      title: "",
      props: {},
      action: "",
      actionData: null
    },
    _lastFocusedElement: null,
    open: (component = null, options) => {
      modalConfig._lastFocusedElement =
        typeof document !== "undefined" ? document.activeElement : null
      modalConfig.options = { ...options, visible: true }
      modalConfig.component = component
        ? shallowRef(component)
        : modalConfig.component
    },
    close: () => {
      const returnTo = modalConfig._lastFocusedElement
      const pendingAction = modalConfig.options?.action || ""
      const pendingActionData = modalConfig.options?.actionData ?? null
      modalConfig.component = null
      modalConfig.options = {
        visible: false,
        ...(pendingAction
          ? { action: pendingAction, actionData: pendingActionData }
          : {})
      }
      nextTick(() => {
        restoreFocus(returnTo)
        // Fallback pass for slow DOM transition states used by CoreUI modal.
        setTimeout(() => {
          restoreFocus(returnTo)
        }, 50)
        modalConfig._lastFocusedElement = null
      })
    },
    setAction: (actionName, data = null) => {
      modalConfig.options.action = actionName
      modalConfig.options.actionData = data
    }
  })

  app.provide("modal", modalConfig)
  app.config.globalProperties.$modal = modalConfig
}

export default modalPlugin
